import React, { useEffect, useState } from 'react'
import Chart from '../../../../../components/Rechart/Chart';
import http from '../../../../../config/BaseUrl';

function SmsShare() {

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get(`dashboard-graph/sharing/sms`).then( res =>{
        if(res.data.graphData){
          setData(res.data.graphData)
          setIsLoading(false)
        }
      }).catch((err) => {
        console.log('fail');
        setIsLoading(false)
      })
    } catch (error) {
      
    }
  }


  useEffect(()=>{
    fetchGraphData()
  }, [])

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }


  return (
    <Chart 
      sectionTitle={"Sms"} 
      sectionName={"sms"} 
      loading={isLoading}
      dataSet={data} 
      width={330} 
      height={180} 
      dataKey={"share"} 
      graphTotalText={graphTotalText}
    />
  )
}

export default SmsShare
